module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/training-unit-lvl2-50.10e57e2f.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/training-unit-lvl2-50.png
// module id = 3565
// module chunks = 11